import { IApplicationState } from '../../types/redux';
import { INewbuildingsCompareBlock } from '../../types/newbuildingsCompare';

export function selectNewbuildingsCompareBlocks(state: IApplicationState): INewbuildingsCompareBlock[] {
  return state.newbuildingsComparison?.blocks ?? [];
}
